import React from "react";
import {
  Box,
  Card,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  Divider
} from "@mui/material";

const border = "1px solid #dcdcdc";
const sectionHeader = {
  backgroundColor: "#f3f6f9",
  fontWeight: 700
};

const DeclarationImpartiality = ({ data }) => {
  if (!data || data.length === 0) return null;

  return (
    <Box sx={{ mb: 4 }}>
      <Card elevation={3}>
        {/* HEADER */}
        <Box
          sx={{
            background:
              "linear-gradient(135deg, #141e30 0%, #243b55 100%)",
            color: "#fff",
            textAlign: "center",
            py: 2
          }}
        >
          <Typography variant="h6" fontWeight={700}>
            DECLARATION OF IMPARTIALITY & CONFIDENTIALITY
          </Typography>
          <Typography variant="caption">
            (Form 74)
          </Typography>
        </Box>

        {/* DECLARATION TEXT */}
        <Box sx={{ p: 3 }}>
          <Typography variant="body2" paragraph>
            I declare that I have reviewed assessment related documents and found the same to be appropriate/adequate to conduct the assessment.
          </Typography>

          <Typography variant="body2" paragraph>
          <strong>Note:</strong> While reviewing the documents and records supplied by NABL and CAB, if you observe any gross anomalies, please immediately inform dealing officer in NABL (through email).
          </Typography>
        </Box>

        <Divider />

        {/* DECLARATION TABLE */}
        <TableContainer component={Paper}>
          <Table size="small">
            <TableBody>
              <TableRow sx={sectionHeader}>
                <TableCell colSpan={6} sx={border} align="center">
                  Declaration by Assessors
                </TableCell>
              </TableRow>

              <TableRow sx={sectionHeader}>
                <TableCell colSpan={2} sx={border} align="center">
                  Assessor Name
                </TableCell>
                <TableCell colSpan={2} sx={border} align="center">
                  Ex-Employee of CAB
                </TableCell>
                <TableCell colSpan={2} sx={border} align="center">
                  Related to CAB Management
                </TableCell>
              </TableRow>

              {data.map((item, index) => (
                <TableRow key={index}>
                  <TableCell
                    colSpan={2}
                    sx={border}
                    align="center"
                  >
                    <Typography fontWeight={600}>
                      {item.Name}
                    </Typography>
                  </TableCell>

                  <TableCell colSpan={2} sx={border} align="center">
                    <Typography
                      fontWeight={600}
                      color={
                        item.isExEmployee === "1"
                          ? "error.main"
                          : "success.main"
                      }
                    >
                      {item.isExEmployee === "1" ? "Yes" : "No"}
                    </Typography>
                  </TableCell>

                  <TableCell colSpan={2} sx={border} align="center">
                    <Typography
                      fontWeight={600}
                      color={
                        item.isCabRelation === "1"
                          ? "error.main"
                          : "success.main"
                      }
                    >
                      {item.isCabRelation === "1" ? "Yes" : "No"}
                    </Typography>
                  </TableCell>
                </TableRow>
              ))}

              {/* SIGNATURE PLACEHOLDER */}
              {/* <TableRow>
                <TableCell colSpan={6} sx={{ border, p: 2 }}>
                  <Typography variant="body2">
                    Signature of Assessor(s):
                  </Typography>
                  <Box sx={{ mt: 2, height: 40, borderBottom: "1px solid #999" }} />
                </TableCell>
              </TableRow> */}

            </TableBody>
          </Table>
        </TableContainer>
      </Card>
    </Box>
  );
};

export default DeclarationImpartiality;
